import _ from 'lodash'
import dayjs from "dayjs";
import holidays from "@holiday-jp/holiday_jp";
import { sekki } from "@/util/days";

export const yyyymmdd = (date = new Date()) => {
  const day = dayjs(date)
  return day.isValid() ? day.format('YYYY年MM月DD日') : ''
}

export const isSunday = ({date}) => {
  return dayjs(date).format('ddd') === '日'
}
export const isSaturday = ({date}) => {
  return dayjs(date).format('ddd') === '土'
}

export const todayInfo = ({date}) => {
  if (!date) {
    return {}
  }
  const targetDay = dayjs(date)
  const year = Number.parseInt(targetDay.format('YYYY'))
  const month = Number.parseInt(targetDay.format('M'))
  const day = Number.parseInt(targetDay.format('D'))
  const sekkiInfo = _.find(sekki, {year, month, day})

  const holiday = holidays.between(date, date);
  return {
    holidayName: holiday.length > 0 ? holiday[0].name : '',
    sekkiName: (sekkiInfo || {}).name,
    isSaturday: isSaturday({date}),
    isSunday: isSunday({date}),
    isHoliday: holiday.length > 0,
    isSekki: sekkiInfo !== undefined
  }
}
